import { render, staticRenderFns } from "./HomeFrame.vue?vue&type=template&id=5b023b35&scoped=true"
import script from "./HomeFrame.vue?vue&type=script&lang=js"
export * from "./HomeFrame.vue?vue&type=script&lang=js"
import style0 from "./HomeFrame.vue?vue&type=style&index=0&id=5b023b35&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b023b35",
  null
  
)

export default component.exports